import InvestmentAmount from './InvestmentAmount'

export default InvestmentAmount
